export const SHOW_CANCEL_MODAL = 'SHOW_CANCEL_MODAL ';
export const LOAD_VERIFICATION_FIELDS_SUCCESS = 'LOAD_VERIFICATION_FIELDS_SUCCESS';
export const LOAD_PASSWORD_RULES = 'LOAD_PASSWORD_RULES';
export const SET_SIGN_UP_VERIFIED_IDENTITY_DATA = 'SET_SIGN_UP_VERIFIED_IDENTITY_DATA';
export const SET_AUTHORIZED_REP_DATA = 'SET_AUTHORIZED_REP_DATA';
